import { render, staticRenderFns } from "./CandidateListTab.vue?vue&type=template&id=e77e2228"
import script from "./CandidateListTab.vue?vue&type=script&lang=js"
export * from "./CandidateListTab.vue?vue&type=script&lang=js"
import style0 from "./CandidateListTab.vue?vue&type=style&index=0&id=e77e2228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports